//
//
//
//
//
//
import { image } from "@/utils/Tool";
export default {
  name: "cpt-image",
  props: {
    option: Object
  },
  data: function data() {
    return {};
  },
  methods: {
    image: image
  }
};